import React from "react";
import { View, StyleSheet } from "react-native";
import { useNavigation, type NavigationProp } from "@react-navigation/native";
import {
  QuestionLayout,
  SquareOptionButton,
} from "@src/packages/medical-history/components";
import { useTranslations } from "@src/packages/i18n";
import { useFamilyHistory } from "../FamilyHistoryContext";
import type { FamilyHistoryStackParamList } from "../FamilyHistoryNavigator";
import { FAMILY_MEMBER_OPTIONS, type FamilyMemberEnum } from "../options";

export function FamilyMemberScreen() {
  const t = useTranslations();
  const { state, updateState } = useFamilyHistory();
  const navigation =
    useNavigation<NavigationProp<FamilyHistoryStackParamList>>();

  const selected = new Set(state.familyMemberWithFertilityIssues);

  const toggle = (id: FamilyMemberEnum) => {
    const next = new Set(selected);
    if (next.has(id)) {
      next.delete(id);
    } else {
      next.add(id);
    }
    updateState({ familyMemberWithFertilityIssues: Array.from(next) });
  };

  const handleNext = () => {
    navigation.navigate("Des");
  };

  return (
    <QuestionLayout
      title={t("med_history.family_history.family_member_title")}
      subtitle={t("med_history.family_history.family_member_subtitle")}
      onBack={() => navigation.goBack()}
      onSave={handleNext}
      saveDisabled={state.familyMemberWithFertilityIssues.length === 0}
      saveLabel={t("med_history.shared.next")}
    >
      <View style={styles.grid}>
        {FAMILY_MEMBER_OPTIONS.map((option) => (
          <View
            key={option.id}
            style={option.id === "other" ? styles.fullWidth : styles.cell}
          >
            <SquareOptionButton
              icon={option.icon}
              label={t(option.labelKey)}
              isSelected={selected.has(option.id)}
              onPress={() => toggle(option.id)}
              labelSize="sm"
            />
          </View>
        ))}
      </View>
    </QuestionLayout>
  );
}

const styles = StyleSheet.create({
  grid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 12,
    width: "100%",
    marginBottom: 40,
  },
  cell: {
    width: "47%",
  },
  fullWidth: {
    width: "100%",
  },
});
